var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-mb--m"},_vm._l((_vm.faqs),function(faq,index){return _c('div',{key:index},[_c('h3',[_vm._v(" "+_vm._s(faq.heading)+" ")]),_c('FaqAccordion',{attrs:{"faqs":faq.items}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }